<section>
    <h4 class="page-title">Company Investigation Report</h4>
    <kendo-card width="100%">
        <div class="content-wrapper">
            <app-report-table [config]="tableConfig"></app-report-table>
        </div>
    </kendo-card>
</section>
